import type { InterventionProps } from "../types";
import { PricingNudgeIntervention } from "./PricingNudgeIntervention";
import { PopupControlIntervention } from "./PopupControlIntervention";
import { EmbedTrustPlatformBanner } from "./EmbedTrustPlatformBanner/EmbedTrustPlatformBanner";
import { TradeBasedAverageClaims } from "./TradeBasedAverageClaims";
import { ClickableTrustpilotBanner } from "./ClickableTrustpilotBanner/ClickableTrustpilotBanner";

export const getInterventionComponent = (
  props: InterventionProps,
  componentName: string,
) => {
  switch (componentName) {
    case "control":
    case "popup-control":
      return <PopupControlIntervention />;
    case "indicative-pricing":
      return <PricingNudgeIntervention {...props} />;
    case "claims-popup-average":
      return <TradeBasedAverageClaims {...props} />;
    case "embed-trust-platform-trustpilot":
      return <EmbedTrustPlatformBanner />;
    default:
      break;
  }
  return null;
};

/*
  Notes:
  - This is used in Q2Q journeys, not Legacy
  - We pass the intervention name instead of the component name here
  - The Intervention component returned received props from the InterventionWrapper
  - If there are variants (including control) the logic to handle them should be inside the Interventions component itself
*/
export const getReactInterventionComponent = (interventionName: string) => {
  switch (interventionName) {
    case "trust-pilot-banner-clickable":
      return <ClickableTrustpilotBanner />;
    case "biz-indicative-pricing-popup":
    case "biz-msm-indicative-pricing-popup":
      return <PricingNudgeIntervention />;
    default:
      break;
  }
  return null;
};
